import React from 'react';
import { ExternalLink } from 'lucide-react';

interface GoogleAnalyticsButtonProps {
  className?: string;
}

const GoogleAnalyticsButton: React.FC<GoogleAnalyticsButtonProps> = ({ className = '' }) => {
  // Google Analytics URL for your property - replace with your actual property/view ID if needed
  const gaUrl = 'https://analytics.google.com/analytics/web/?authuser=0#/p345365971/reports/intelligenthome';
  
  return (
    <a 
      href={gaUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 hover:bg-blue-100 rounded-md transition-colors ${className}`}
    >
      <ExternalLink size={16} />
      <span>View in Google Analytics</span>
    </a>
  );
};

export default GoogleAnalyticsButton;
